import React from 'react'
import { useTranslation } from 'react-i18next'


const SelectRegistrationCompanyPanel = ({ registrationCompanies, handleSelectRegistrationCompany, title }) => {
    const { t } = useTranslation();
    return (
        <div className='table-responsive'>
            <table className='table table-bordered'>
                <thead>
                    <tr>
                        {registrationCompanies.length > 0 && !registrationCompanies[0].fromGus && <th style={{ width: '10%' }}>Kod</th>}
                        <th style={{ width: '35%' }}>{t("company_Name")}</th>
                        <th style={{ width: '20%' }}>{t("street")}</th>
                        <th style={{ width: '20%' }}>{t("region")}</th>
                        <th style={{ width: '15%' }}>{t("city")}<br />
                            {t("zipCode")}</th>
                        <th style={{ width: '15%', textAlign: 'center' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {registrationCompanies.map((row) => (
                        <tr class="hoverable-row table-vertical-aligne" key={row.id}>
                            {registrationCompanies.length > 0 && !registrationCompanies[0].fromGus && <td>{row.companyCode}</td>}
                            <td>{row.companyName}</td>
                            <td>{row.street} {row.houseNumber}{row.localNumber ? '/' + row.localNumber : ''}</td>
                            <td>{row.province}</td>
                            <td>{row.city}<br />
                                {row.zipCode}</td>
                            <td style={{ textAlign: 'center' }}>
                                <button onClick={() => (handleSelectRegistrationCompany(row))} className='btn-app-primary' style={{ cursor: 'pointer', fontSize: "14px" }}>
                                    {t("select")}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default SelectRegistrationCompanyPanel